import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";

export default function Browse() {
  const { kind } = useParams(); // "hermitages" | "hermits"
  const listing_type = kind === "hermits" ? "hermit_offer" : "hermitage";
  const [region, setRegion] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { listing_type };
    if (region) params.region = region;
    api
      .get("/listings", { params })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [listing_type, region]);

  const title = kind === "hermits" ? "Hermits seeking a hearth" : "Hermitages awaiting a hermit";
  const subtitle =
    kind === "hermits"
      ? "Wandering souls offering presence in exchange for a roof."
      : "Mossy cottages, walled gardens, and quiet acres seeking a custodian.";

  return (
    <main className="max-w-7xl mx-auto px-6 sm:px-10 py-12">
      <div className="grid grid-cols-12 gap-6 items-end mb-10">
        <div className="col-span-12 md:col-span-7">
          <p className="label-overline">Listings</p>
          <h1 className="font-display text-5xl mt-2">{title}</h1>
          <p className="font-body text-ink-iron mt-3 text-lg">{subtitle}</p>
        </div>
        <div className="col-span-12 md:col-span-5 flex flex-wrap gap-3 md:justify-end">
          <Link to="/browse/hermitages" data-testid="tab-hermitages" className={`label-overline px-4 py-2 border ${kind !== "hermits" ? "bg-ink-black text-parchment-faded border-ink-black" : "border-rule"}`}>Hermitages</Link>
          <Link to="/browse/hermits" data-testid="tab-hermits" className={`label-overline px-4 py-2 border ${kind === "hermits" ? "bg-ink-black text-parchment-faded border-ink-black" : "border-rule"}`}>Hermits</Link>
          <select
            data-testid="region-filter"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            className="field w-auto"
          >
            <option value="">All regions</option>
            <option value="USA">USA</option>
            <option value="UK">UK</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>

      {loading ? (
        <p className="marginalia">Reading the parchment…</p>
      ) : items.length === 0 ? (
        <div className="parchment-card text-center">
          <p className="font-display italic text-2xl">No listings yet in this corner.</p>
          <p className="font-body text-ink-iron mt-3">Perhaps thee shall be the first.</p>
          <Link to="/listings/new" className="wax-button mt-6 inline-block">Post a listing</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((l) => (
            <Link
              to={`/listings/${l.listing_id}`}
              key={l.listing_id}
              data-testid={`listing-card-${l.listing_id}`}
              className="parchment-card flex flex-col hover:bg-parchment-bone transition-colors"
            >
              {l.image_url && (
                <img src={l.image_url} alt={l.title} className="w-full h-48 object-cover border border-rule mb-4 -mx-2" />
              )}
              <p className="label-overline">{l.region} · {l.listing_type === "hermitage" ? "Hermitage" : "Hermit"}</p>
              <h3 className="font-display text-2xl mt-2">{l.title}</h3>
              <p className="font-body text-ink-iron mt-2 flex-1">{l.summary}</p>
              <p className="label-overline mt-4 text-wax-red">{l.duration}</p>
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}
